// extracted by mini-css-extract-plugin
export default {"column":"GroupColumn_column__QKeH5","header":"GroupColumn_header__M+nCA","error":"GroupColumn_error__WO25C"};